export default __webpack_public_path__ + "static/media/fross6.470130ad.png";